import React from "react";
import { useTranslation } from "react-i18next";

import AddPhone from "../add-phone/add-phone.component";
import VerifyNumber from "./verifyNumber";
import Loader from "../../common/loader/loader.component";
import { ReactComponent as CheckmarkIcon } from "../../../assets/checkmark.svg";
import { ReactComponent as RemoveIcon } from "../../../assets/cross.svg";
import { useVerifyNumber } from "./useVerifyNumber";
import { useStyles } from "./verify-number-container.styles";
import { VerifyNumberContainerProps } from "./verify-number-container.types";

const VerifyNumberContainer: React.FC<VerifyNumberContainerProps> = ({
  handleClose,
  phoneNumber,
  setPhoneValue,
  onVerifyFunc,
  onVerified,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    addPhoneScreen,
    isVerified,
    onVerify,
    onChangeNumber,
    onResend,
    isLoading,
  } = useVerifyNumber({ phoneNumber, onVerifyFunc, onVerified });

  if (isLoading) {
    return (
      <div className={classes.loaderContainer}>
        <Loader color={"#B73232"} size={50} />
      </div>
    );
  }

  if (isVerified) {
    return (
      <div className={classes.successContainer}>
        <div className={classes.successHeader}>
          <span className="pointer" onClick={handleClose}>
            <RemoveIcon style={{ height: 24, width: 24 }} />
          </span>
        </div>
        <div className={classes.successBody}>
          <div className={classes.successIconWrapper}>
            <CheckmarkIcon className={classes.successIcon} />
          </div>
          <span className={classes.successMessage}>
            {t("verifyNumber.verifiedSuccessfully")}
          </span>
        </div>
      </div>
    );
  }

  return addPhoneScreen ? (
    <AddPhone
      onChangeNumber={onChangeNumber}
      handleClose={handleClose}
      phoneValue={phoneNumber}
      setPhoneValue={setPhoneValue}
    />
  ) : (
    <VerifyNumber
      onChangeNumber={onChangeNumber}
      handleClose={handleClose}
      onVerify={onVerify}
      phoneNumber={phoneNumber}
      onResend={onResend}
    />
  );
};

export default VerifyNumberContainer;
